module.exports = __webpack_public_path__ + "img/designer.aa27d990.webp";